<script lang="ts">
  import { go } from "../../lib/router.svelte";
</script>

<section class="max-w-md mx-auto px-6 py-24 text-center">
  <h1 class="text-3xl font-bold">Page not found</h1>
  <a
    href="/"
    onclick={(e) => go(e, "/")}
    class="mt-6 inline-block px-5 py-3 rounded-md border border-white/15 hover:border-white/30"
  >
    Home
  </a>
</section>
